<template>
  <div class="product">
    <div class="product__img">
      <img v-bind:src="product.image" alt="">
    </div>

    <div class="product__info">
      <span class="product__brand">{{ (product.brands && product.brands[0]) ? product.brands[0].name : '' }}</span>
      <!--<span class="product__size">0.5 Liter Bottled Water</span>-->
      <span class="product__name" v-html="product.name"></span>
      <span class="product__qty">{{ product.size }}</span>
      <span class="product__price">${{ product.price }} {{ product.price_label ?? 'ea' }}</span>

      <div v-html="product.description"></div>

      <div class="product__options">
        <label for="quantity" class="mb-0">Quantity</label>
        <select name="quantity" id="quantity" v-model="quantity" class="form-select form-select-sm w-auto" required>
          <option v-for="i in range" v-bind:value="i">{{ i }}</option>
        </select>

        <div v-if="flavors && flavors.length > 0">
          <label for="flavor" class="mb-0">Flavor</label>
          <select name="flavor" id="flavor" v-model="flavor" required>
            <option 
              v-for="flavor in flavors" 
              v-bind:value="flavor.id" 
            >{{ flavor.name }}{{ flavor.price ? ': $' + flavor.price : '' }}</option>
          </select>
        </div>
      </div> <!-- .product__options -->

      <button type="button" class="btn btn-store" v-on:click="addToCart()">Add to Order</button>
    </div>
  </div> <!-- .product -->
</template>

<script>
import store from '../../store.js'

export default {
  props: ['product'],
  data() {
    return {
      quantity: null,
      flavor: null,
    }
  },
  computed: {
    flavors() {
      return this.product.flavors
    },
    minQty() {
      return this.product.minimumQuantity || 1
    },
    maxQty() {
      return this.product.maximumQuantity || 10
    },
    range() {
      let range = []
      for (let i = this.minQty; i <= this.maxQty; i++) {
        range.push(i)
      }
      return range
    }
  },
  mounted() {
    if (! this.quantity) {
      this.quantity = this.minQty
    }

    if (this.flavors && this.flavors.length) {
      this.flavor = this.flavors[0].id
    }
  },
  methods: {
    addToCart() {
      if (! this.quantity) {
        swal('Whoops!', 'Please select a quantity.')
        return
      }

      if (this.flavors && this.flavors.length > 0 && ! this.flavor) {
        swal('Whoops!', 'Please select a flavor.')
        return
      }

      // Add to Cart
      store.dispatch('addToCart', {
        productId: this.product.id,
        options: {
          quantity: parseInt(this.$data.quantity),
          flavor: this.$data.flavor,
        }
      })

      // Go to Order Summary
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      store.dispatch('goToOrderSummary')
    }
  }
}
</script>
